




































































import { Notificacao } from '@/models'
import { formatarDataHora } from '@/shareds/formatadores'
import NotificacaoStore from '@/store/vuex/aplicacao/NotificacaoStore'
import { DispensarNotificacao } from '@/usecases'
import moment from 'moment'
import { Vue, Component } from 'vue-property-decorator'

@Component
export default class MenuDeNotificacao extends Vue {
	dispensarNotificacao = new DispensarNotificacao()

	formatarDataHora = formatarDataHora

	get notificacoes() {
		return NotificacaoStore.notificacoes
	}
	
	set notificacoes(notificaco: Notificacao[]) {
		NotificacaoStore.setNotificacoes(notificaco)
	}

	get notificacoesOrdenadas() {
		return [...this.notificacoes].sort((notificacaoA, notificacaoB) => moment(notificacaoB.dataEHora).diff(notificacaoA.dataEHora))
	}

	async limparNotificacao(notificacao: Notificacao) {
		const indice = this.notificacoes.findIndex(notificacaoExistente => notificacaoExistente.id === notificacao.id)
		if(indice === -1) return

		const notificacoes = [...this.notificacoes]
		notificacoes.splice(indice, 1)
		this.notificacoes = notificacoes

		await this.dispensarNotificacao.executar(notificacao)
	}
}
